import { render, staticRenderFns } from "./LinksForm.vue?vue&type=template&id=a5cb688c"
import script from "./LinksForm.vue?vue&type=script&lang=js"
export * from "./LinksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports